import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../redux/store'
import { getSubZonesActionAsync } from '../redux/actions/subzoneActions'

export const useSubZones = () => {
  const { subzonesState } = useSelector((state: RootState) => state.subzone)
  const dispatch = useDispatch()

  const getSubZones = () => {
    dispatch(getSubZonesActionAsync())
  }

  return { subzonesState, getSubZones }
}
